module.exports = __webpack_public_path__ + "static/media/drivers.2d8c95f7.svg";